<template>
  <div id="students" class="w-full mx-auto max-w-7xl md:px-8 md:mb-8">
    <div class="mx-4 my-6 md:flex md:items-center md:justify-between md:mx-0">
      <h1 class="mr-4 text-2xl font-semibold">My Students</h1>

      <div class="grid grid-cols-2 gap-4 mt-4 md:flex">
        <div
          class="col-span-2 md:ml-4 md:order-3"
          role="region"
          aria-label="Prospective Student"
        >
          <button
            class="modal hover:bg-teal-100 hover:text-white focus:bg-teal-100 focus:text-white"
            @click="openModal"
          >
            <i class="mdi mdi-plus-circle-outline mr-2"></i>
            Prospective Student
          </button>
        </div>
        <portal-target name="searchbox" role="search" aria-label="Students" />

        <portal-target name="filter" />
      </div>
    </div>
    <tabs />

    <tab-content />
    <modal
      :title="'Add a prospective student'"
      :id="'prospective'"
      v-if="prospectiveModal"
      @closeModal="closeModal"
    >
      <prospective-content
        :in-modal="true"
        @close="closeModal"
        slot="modal-content"
      />
    </modal>

  </div>
</template>

<script>
import modal from "@/components/modal.vue";
import prospectiveContent from "@/components/SiteComponents/prospectiveStudent.vue";
import tabContent from "@/components/dataTables/TabContentComponent";
import tabs from "@/components/dataTables/TabsComponent";

export default {
  components: {
    tabs,
    tabContent,
    modal,
    prospectiveContent
  },
  data() {
    return {
      prospectiveModal: false, // show prospective modal
      priceBreakDownModal: false
    };
  },
  created() {
    this.$store.commit("setApplicationId", ""); // Remove application ID when entering to table
  },
  methods: {
    closeModal() {
      this.prospectiveModal = false;
    },
    openModal() {
      this.prospectiveModal = true;
    },
    openPriceBreak() {
      this.priceBreakDownModal = true;
    },
    closePriceBreak() {
      this.priceBreakDownModal = false;
    }
  }
};
</script>
